import React from 'react';
import GamesContainer from './GamesContainer';

const GamesView = () => {
  return <GamesContainer />;
};

export default GamesView;
